var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-page-content-wrapper api-access" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("settings.apiAccessTitle"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.$t("settings.apiAccessSubtitles"))),
      ]),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        [
          _c(
            "a-card",
            {
              staticStyle: { width: "500px" },
              attrs: { title: _vm.$t("settings.apiAccessTokenCardTitle") },
            },
            [
              _c(
                "a-card-grid",
                { staticStyle: { width: "100%", "text-align": "center" } },
                [
                  !!_vm.access_token
                    ? _c("div", { staticClass: "tokenView" }, [
                        _c("div", [_vm._v(_vm._s(_vm.access_token.token))]),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-card-grid",
                {
                  staticStyle: { width: "100%", "text-align": "center" },
                  attrs: { hoverable: false },
                },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "btnColor",
                      attrs: { type: "primary", danger: "", ghost: "" },
                      on: { click: _vm.generateToken },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.generateToken")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "btnColor",
                      attrs: { type: "primary", danger: "", ghost: "" },
                      on: { click: _vm.copyAccessToken },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.copyToken")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "btnColor",
                      attrs: { type: "secondary", danger: "", ghost: "" },
                      on: { click: _vm.goToApiDoc },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.ApiDoc")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }